import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import {
  Package,
  Factory,
  PackageCheck,
  PackageX,
  PackagePlus,
  DollarSign,
  ArrowDownUp,
  TrendingUp,
} from "lucide-react";

interface SeedOption {
  value: number;
  label: string;
}

interface FactoryOption {
  value: number;
  label: string;
}

const ReportPage: React.FC = () => {
  const [dataFactoryList, setDataFactoryList] = useState<any[]>([]);
  const [dataSeedList, setDataSeedList] = useState<any[]>([]);
  const [dataFactoryID, setDataFactoryID] = useState<number | null>(null);
  const [dataSeedID, setDataSeedID] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [reload, setReload] = useState(false);

  const [reportData, setReportData] = useState({
    total_amount_paid_factory: 0,
    total_amount_received_farmer: 0,
    total_contractor_profit: 0,
    total_received_seed_count: 0,
    total_remaining_seed_count: 0,
    total_seed_delivered_to_farmer_count: 0,
  });
  const cropYearID = localStorage.getItem("crop_year_id");
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropYearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  // Fetch factory options on component mount
  useEffect(() => {
    const fetchFactories = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/factory/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setDataFactoryList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت لیست کارخانه‌ها:", error);
      }
    };

    fetchFactories();
  }, []);

  // Fetch seed options on component mount
  useEffect(() => {
    const fetchSeeds = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/seed/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setDataSeedList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت لیست بذرها:", error);
      }
    };

    fetchSeeds();
  }, []);

  // Fetch report data when selections change
  useEffect(() => {
    const fetchReportData = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = localStorage.getItem("app_atkey");
        const body = {
          factory_id: dataFactoryID ? dataFactoryID : null,
          seed_id: dataSeedID ? dataSeedID : null,
        };
        const cropID = Number(localStorage.getItem("crop_year_id"));
        const response = await axios.post(
          `https://api.havirkesht.ir/report-seed/?crop_year_id=${cropID}`,
          body,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response, "response");

        setReportData({
          total_amount_paid_factory:
            response.data.total_amount_paid_factory || 0,
          total_amount_received_farmer:
            response.data.total_amount_received_farmer || 0,
          total_contractor_profit: response.data.total_contractor_profit || 0,
          total_received_seed_count:
            response.data.total_received_seed_count || 0,
          total_remaining_seed_count:
            response.data.total_remaining_seed_count || 0,
          total_seed_delivered_to_farmer_count:
            response.data.total_seed_delivered_to_farmer_count || 0,
        });
      } catch (err) {
        setError("خطا در دریافت گزارش");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [reload, dataFactoryID, dataSeedID]);

  // Trigger reload when filters change
  useEffect(() => {
    setReload(!reload);
  }, []);

  // تابع برای فرمت کردن اعداد با جداکننده هزارگان
  const formatNumber = (num: number) => {
    return num?.toLocaleString("fa-IR");
  };

  return (
    <div className="container mx-auto p-4 dark:bg-gray-900 dark:text-gray-100">
      <h1 className="text-2xl font-bold mb-6 text-right dark:text-white">
        گزارش‌ بذر
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="flex flex-col">
          <label className="text-base font-medium mb-1 dark:text-gray-300">
            نام کارخانه:
          </label>
          <Select
            options={[
              { value: null, label: "انتخاب همه..." },
              ...dataFactoryList.map((item) => ({
                value: item.id,
                label: item.factory_name,
              })),
            ]}
            defaultValue={{ value: null, label: "انتخاب همه..." }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                backgroundColor: "inherit",
              }),
              option: (base) => ({
                ...base,
                color: "inherit",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }),
            }}
            menuPortalTarget={document.body}
            onChange={(selected: any) => setDataFactoryID(selected.value)}
            placeholder="جستجو..."
            noOptionsMessage={() => "داده‌ای یافت نشد"}
            className="w-full my-react-select-container dark:text-gray-900"
            classNamePrefix="my-react-select"
            isSearchable
          />
        </div>

        <div className="flex flex-col">
          <label className="text-base font-medium mb-1 dark:text-gray-300">
            نام بذر:
          </label>
          <Select
            options={[
              { value: null, label: "انتخاب همه..." },
              ...dataSeedList.map((item) => ({
                value: item.id,
                label: item.seed_name,
              })),
            ]}
            defaultValue={{ value: null, label: "انتخاب همه..." }}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                backgroundColor: "inherit",
              }),
              option: (base) => ({
                ...base,
                color: "inherit",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }),
            }}
            menuPortalTarget={document.body}
            onChange={(selected: any) => setDataSeedID(selected.value)}
            placeholder="جستجو..."
            noOptionsMessage={() => "داده‌ای یافت نشد"}
            className="w-full my-react-select-container dark:text-gray-900"
            classNamePrefix="my-react-select"
            isSearchable
          />
        </div>
      </div>

      {loading && (
        <div className="text-center py-4 dark:text-gray-300">
          در حال دریافت داده‌ها...
        </div>
      )}

      {error && (
        <div className="bg-red-100 dark:bg-red-900 dark:bg-opacity-20 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 px-4 py-3 rounded relative mb-4 text-right">
          {error}
        </div>
      )}

      {!loading && !error && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-6 dark:text-white text-right">
            {`  گزارش بذر بر اساس سال زراعی ${YearCoptSelect}`}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* بذر دریافتی */}
            <div className="bg-blue-50 dark:bg-blue-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <PackagePlus
                  className="text-blue-600 dark:text-blue-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  تعداد بذر های دریافتی از کارخانه
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_received_seed_count)}
              </p>
            </div>

            {/* بذر تحویل داده شده */}
            <div className="bg-green-50 dark:bg-green-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <PackageCheck
                  className="text-green-600 dark:text-green-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  تعداد بذرهای تحویل داده شده به کشاورز
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_seed_delivered_to_farmer_count)}
              </p>
            </div>

            {/* بذر باقیمانده */}
            <div className="bg-yellow-50 dark:bg-yellow-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <PackageX
                  className="text-yellow-600 dark:text-yellow-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  تعداد بذر های باقی مانده
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_remaining_seed_count)}
              </p>
            </div>

            {/* پرداختی به کارخانه */}
            <div className="bg-purple-50 dark:bg-purple-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <DollarSign
                  className="text-purple-600 dark:text-purple-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  کل مبلغ پرداختی بذر به کارخانه
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_amount_paid_factory)} تومان
              </p>
            </div>

            {/* دریافتی از کشاورز */}
            <div className="bg-teal-50 dark:bg-teal-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <ArrowDownUp
                  className="text-teal-600 dark:text-teal-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  کل مبلغ دریافت شده بابت بذر از کشاورزان
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_amount_received_farmer)} تومان
              </p>
            </div>

            {/* سود پیمانکار */}
            <div className="bg-emerald-50 dark:bg-emerald-900 dark:bg-opacity-20 p-4 rounded-lg">
              <div className="flex items-center">
                <TrendingUp
                  className="text-emerald-600 dark:text-emerald-400 mr-2"
                  size={20}
                />
                <span className="font-medium dark:text-gray-300">
                  سود پیمانکار در بذر
                </span>
              </div>
              <p className="text-lg mt-2 dark:text-white">
                {formatNumber(reportData.total_contractor_profit)} تومان
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportPage;
